import { updateResource } from "./api";

const markSeenById = async (id) => {
  const url = `/notify/api/seen_webapp_notifications/${id}`;
  return updateResource(url, {});
};

export default { markSeenById };
